'use client';

import clsx from 'clsx';
import type { QuoteBlockProps } from './types';

export default function QuoteBlock({ text, subtitle, classNames = {}, className }: QuoteBlockProps) {
    const { root, bg, inner, text: textClass, subtitle: subtitleClass } = classNames;
    return (
        <div className={clsx(root, className)}>
            <div className={clsx(bg)} aria-hidden />
            <div className={clsx(inner)}>
                <p className={clsx(textClass)}>{text}</p>
                {subtitle != null && <p className={clsx(subtitleClass)}>{subtitle}</p>}
            </div>
        </div>
    );
}
